import {
  EScenarioActionKeys,
  EScenarioActionMethod,
  TFormParameterListContent,
} from '~/features/scenarios/models'

export type TActionStep = TActionInstructionStep | TActionApiCallStep

export type TActionStepBase = {
  id: string
  type: EActionStepType
  description: string
  [EScenarioActionKeys.actionIds]?: string[]
}

export enum EActionStepType {
  INSTRUCTION = 'instruction',
  API_CALL = 'apiCall',
}

export type TActionInstructionStep = TActionStepBase & {
  type: EActionStepType.INSTRUCTION
}

export type TFormHeaderListContent = {
  id: string
  key: string
  value: string
}

export type TActionApiCallStep = TActionStepBase & {
  type: EActionStepType.API_CALL
  enableNewApiActions?: boolean
  [EScenarioActionKeys.webhook]?: string
  [EScenarioActionKeys.name]?: string
  [EScenarioActionKeys.method]?: EScenarioActionMethod
  [EScenarioActionKeys.authHeader]?: string
  [EScenarioActionKeys.apiKey]?: string
  [EScenarioActionKeys.waitMessage]?: string
  [EScenarioActionKeys.failureMessage]?: string
  [EScenarioActionKeys.parametersList]?: TFormParameterListContent[]
  [EScenarioActionKeys.headers]?: TFormHeaderListContent[]
  apiActionDescription?: string
}
